




































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { stencilAdd, stencilQuery, companyQuery, taskAdd, checkCompanyExist } from '@/api/document';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

const quarterMap = {
  Q1: '1',
  Q2: '2',
  Q3: '3',
  Q4: '4',
  年度: '5'
};

@Component({})
class CreateTask extends Vue {
  taskInfo: object = {
    date: '',
    mould: '',
    company: ''
  };
  rules: object = {
    mould: [{ required: true, trigger: 'blur' }],
    company: [{ required: true, message: '', trigger: 'blur' }]
  };
  yearSelected: string = '';
  quarterSelected: string = '';
  yearList: any[] = [];
  quarterList: any[] = ['Q1', 'Q2', 'Q3', 'Q4', '年度'];
  quarterMap: object = quarterMap;
  addMould: boolean = false;
  mouldList: any[] = [];
  uploadAction: string = process.env.VUE_APP_BASE_API + '/gather/stencilFileUpload';
  fileList: any[] = [];
  stencilId: string = '';
  showModel: string = '';
  portfolioList: any[] = [];
  portfolioMap: object = {};
  companyList: any[] = [];
  selectedList: any[] = [];
  mouldNameRule: object = {
    mouldName: [{ required: true, message: '请输入模板类型名称', trigger: 'blur' }]
  };
  mouldName: object = {
    mouldName: ''
  };
  popVisible: boolean = false;
  uploadList: object = {};
  placeholder: string = '请输入公司列表，每个公司占一行\nPS：可以直接从excel中复制到这里';
  companyInput: string = '';
  validList: any[] = [];
  invalidList: any[] = [];

  mounted() {
    this.getDateList();
    this.getMouldList();
    this.getPortfolioList();
  }

  @Getter('token') token;

  get headers() {
    return { Authorization: this.token };
  }

  changeYearSelected(value) {
    // this.yearSelected = value;
    localStorage.setItem('portfolioYearSelected', value);
  }

  changeQuarterSelected(value) {
    localStorage.setItem('portfolioQuarterSelected', value);
  }

  onDDLChange(v) {
    localStorage.setItem('portfolioFileDDL', v.format('YYYY-MM-DD'));
  }

  getDateList() {
    let myDate = new Date();
    let year = myDate.getFullYear();
    this.yearList.push(year.toString());
    let num = 1;
    while (num <= 20) {
      this.yearList.push((year + num).toString());
      this.yearList.unshift((year - num).toString());
      num++;
    }
    this.yearSelected = localStorage.getItem('portfolioYearSelected') || '';
    this.quarterSelected = localStorage.getItem('portfolioQuarterSelected') || '';
    if (this.yearSelected === '') {
      this.yearSelected = year.toString();
    }
    if (this.quarterSelected === '') {
      let month = myDate.getMonth();
      let quarter = Math.floor((month + 1) % 3 === 0 ? (month + 1) / 3 : (month + 1) / 3 + 1);
      this.quarterSelected = 'Q' + quarter.toString();
    }
  }

  async getMouldList() {
    try {
      let res = await stencilQuery();
      if (res.code === 200) {
        this.mouldList = res.data;
      } else if (res.code === 403) {
        this.$router.push({ path: '/document/fileCollection/' });
      }
    } catch (err) {
      console.log(err);
    }
  }

  addmould() {
    this.addMould = true;
  }

  handleCancel() {
    this.addMould = false;
  }

  async handleOk() {
    try {
      let res = await stencilAdd({ name: this.mouldName['mouldName'] });
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.addMould = false;
        this.mouldName = { mouldName: '' };
        this.getMouldList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  handleChange(info) {
    const status = info.file.status;
    if (status === 'done') {
      let res = info.file.response;
      let ddlStr = localStorage.getItem('portfolioFileDDL') || '';

      let ddl = moment(new Date(), 'YYYY-MM-DD');
      if (ddlStr !== '') {
        ddl = moment(ddlStr, 'YYYY-MM-DD');
      }
      if (res.code === 200) {
        this.$message.success('上传成功');
        this.fileList.push({
          id: res.data,
          ddl: ddl,
          name: info.file.name
        });
      } else {
        this.$message.error(`文档${info.file.name}上传失败，请联系加加处理`, 5);
      }
    } else if (status === 'error') {
      this.$message.error('上传失败');
      info.file['ddl'] = moment(new Date(), 'YYYY-MM-DD');
    }
  }

  getUploadObj(file) {
    return {
      stencilId: this.stencilId
    };
  }

  addCompany() {
    this.showModel = 'addCompany';
    this.selectedList = this.companyList;
  }

  async getPortfolioList() {
    try {
      let res = await companyQuery();
      if (res.code === 200) {
        this.portfolioList = res.data;
        this.portfolioList.unshift({
          id: -1,
          name: '全选'
        });
        this.portfolioList.forEach(e => {
          this.portfolioMap[e.name] = e.id;
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  portfolioChange(value) {
    this.selectedList = value;
  }

  saveCompany() {
    this.showModel = '';
    if (this.selectedList.includes('全选')) {
      this.companyList = this.portfolioList
        .filter(e => {
          return e.id !== -1;
        })
        .map(e => {
          return e.name;
        });
      this.taskInfo['company'] = this.companyList;
      return;
    }
    this.companyList = this.selectedList;
    this.taskInfo['company'] = this.companyList;
  }

  async createTask() {
    try {
      if (!this.uploadList || Object.keys(this.uploadList).length === 0) {
        this.$message.error('请上传模板文件');
      } else if (!this.companyList || this.companyList.length === 0) {
        this.$message.error('请选择需要完成作业的公司');
      } else {
        let files: any[] = [];
        Object.keys(this.uploadList).forEach(key => {
          this.uploadList[key].forEach(e => {
            let ddl = moment(e.ddl, 'YYYY-MM-DD').format('X');
            files.push({ fileId: e.id, deadline: ddl });
          });
        });
        let companyIds;
        if (this.companyList.includes('全选')) {
          companyIds = this.portfolioList
            .map(e => {
              return e.id;
            })
            .filter(e => {
              return e !== -1;
            });
        } else {
          companyIds = this.companyList.map(e => {
            return this.portfolioMap[e];
          });
        }
        let res = await taskAdd({ year: this.yearSelected, quarter: this.quarterMap[this.quarterSelected], files: files, companyIds: companyIds });
        if (res.code === 200) {
          this.$message.success('保存成功');
          this.back();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  back() {
    this.$router.push({ path: '/document/fileCollection/' });
  }

  deleteCompany(index) {
    this.companyList.splice(index, 1);
  }

  saveFiles() {
    this.showModel = '';
    if (this.uploadList[this.stencilId]) {
      this.uploadList[this.stencilId] = this.uploadList[this.stencilId].concat(this.fileList.slice(0));
    } else {
      this.uploadList[this.stencilId] = [];
      this.uploadList[this.stencilId] = this.fileList.slice(0);
    }
    this.fileList = [];
  }

  deleteFile(id) {
    let uploadList = Object.assign({}, this.uploadList);
    Object.keys(uploadList).forEach(key => {
      uploadList[key] = uploadList[key].filter(e => {
        if (e.id !== id) {
          return e;
        }
      });
      if (uploadList[key].length === 0) {
        delete uploadList[key];
      }
    });
    this.uploadList = uploadList;
  }

  async addList() {
    let companyNames = this.companyInput.split(/[\n]/);
    let res = await checkCompanyExist({
      companyNames: companyNames.join(','),
      forPortfolio: true
    });
    if (res.code === 200) {
      let obj = {};
      this.validList = res.data.valid.filter(item => (obj.hasOwnProperty(item.id) ? false : (obj[item.id] = true)));
      this.invalidList = res.data.invalid;
      let arr = this.validList
        .filter(item => {
          return !this.companyList.some(_ => this.portfolioMap[_] === item.id);
        })
        .map(_ => _.name);
      this.companyList = this.companyList.concat(arr);
    }
  }
}
export default CreateTask;
